import { Component, inject, input, output, signal } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InventoryActionDetailsComponent } from '../inventory-action-details.component';
import { InventoryActionForMovement } from '../../../../models/inventory_action.model';
import { AdminService } from '../../../../admin/services/admin.service';
import { toUnderscore } from '../../../../utils/string-utils';
import { Router } from '@angular/router';

@Component({
    selector: 'app-inventory-action-for-movement-details',
    templateUrl: './inventory-action-for-movement-details.component.html',
    styleUrls: [
        './inventory-action-for-movement-details.component.scss',
        '../inventory-action-details.component.scss',
    ],
    standalone: false
})
export class InventoryActionForMovementDetailsComponent {

  dialogRef = input<MatDialogRef<InventoryActionDetailsComponent>>();
  
  loading = signal<boolean>(false);

  reloadInventoryAction = input(() => {});

  inventoryAction = input<InventoryActionForMovement>();

  public readonly adminService = inject(AdminService);

  public readonly dialog = inject(MatDialog);

  private readonly router = inject(Router);


  get isFinished(): boolean {
    return this.inventoryAction().finish;
  } 

  get isCompleted(): boolean {
    return this.isFinished && this.inventoryAction()?.stock?.status?.completed;
  }

  get title() {
    const action = this.adminService.getText(toUnderscore(this.inventoryAction()?.type));
    return `${action} #${this.inventoryAction()?.correlative_id}`;
  }

  getReceivedProduct(productId) {
    return this.inventoryAction().stock?.inventory_action_products?.find(product => product.product_id === productId);
  }
  
  goBack() {
    if (this.dialogRef() instanceof MatDialogRef) {
      this.dialogRef().close();
    } else {
      this.router.navigate(['/main/inventory/pricings']);
    }
  }

}
